import React from 'react';
import { Text } from '@src/components';
import PropTypes from 'prop-types';
import AddNewCarContainer from './AddNewCarContainer';

const steps = [
  {
    title: 'Sipariş Bilgileri',
    content: AddNewCarContainer,
    key: 'addCarType',
  },
  {
    title: 'Araç Bilgileri',
    content: AddNewCarContainer,
    key: 'addCarPlateInformation',
  },
  {
    title: <Text t="vehicleDetails" />,
    content: AddNewCarContainer,
    key: 'addCarPlateDetail',
  },
  {
    title: <Text t="orderSummary" />,
    content: AddNewCarContainer,
    key: 'addNewCarOrderSummary',
  },
  {
    title: 'Onay',
    content: AddNewCarContainer,
    key: 'addNewCarApproval',
  },
];

const StepContent = ({ activeStep }) => {
  const StepComponent = steps[activeStep]?.content;
  return StepComponent ? <StepComponent /> : null;
};

StepContent.propTypes = {
  activeStep: PropTypes.number.isRequired,
};

export default StepContent;
